import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useIndexCardsStore } from '@/stores'
import { IndexCardListItem } from '@/components/IndexCard'
import '@/components/IndexCard/IndexCard.css'

export default function IndexPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [searchQuery, setSearchQuery] = useState('')
  const { isLoading, fetchIndexCards, getIndexCardsSorted, searchIndexCards, getIndexCardCount } =
    useIndexCardsStore()

  useEffect(() => {
    fetchIndexCards()
  }, [fetchIndexCards])

  const indexCards = searchQuery ? searchIndexCards(searchQuery) : getIndexCardsSorted()
  const totalCount = getIndexCardCount()

  return (
    <div className="index-page">
      <header className="index-page-header">
        <div className="index-page-header-left">
          <h1>
            <span className="topic-id-badge topic-id-badge--index">17/</span>
            {t('index.title')}
          </h1>
          <p>{t('index.subtitle')}</p>
        </div>
        <div className="index-page-header-right">
          <div className="index-search">
            <input
              type="text"
              placeholder={t('index.search')}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
          <button className="btn btn-primary" onClick={() => navigate('/index/new')}>
            {t('index.newEntry')}
          </button>
        </div>
      </header>

      <div className="index-concept-box">
        <p>{t('index.conceptExplanation')}</p>
      </div>

      {isLoading ? (
        <div className="loading-state">
          <span className="spinner"></span>
          <p>{t('common.loading')}</p>
        </div>
      ) : totalCount === 0 ? (
        <div className="index-empty-state">
          <h3>{t('index.noEntries')}</h3>
          <p>{t('index.noEntriesDesc')}</p>
          <button className="btn btn-primary" onClick={() => navigate('/index/new')}>
            {t('index.createEntry')}
          </button>
        </div>
      ) : (
        <div className="index-cards-grid">
          {indexCards.map((indexCard) => (
            <IndexCardListItem key={indexCard.id} indexCard={indexCard} />
          ))}
        </div>
      )}
    </div>
  )
}
